import React from 'react';
import { type ButtonProps } from 'antd';
import * as S from './styles';

interface PrimaryButtonProps extends ButtonProps {
	children: React.ReactNode;
}

export const PrimaryButton = ({ children, ...props }: Readonly<PrimaryButtonProps>) => {
	return (
		<S.PrimaryButton {...props} type="primary">
			{children}
		</S.PrimaryButton>
	);
};
